import { z } from 'zod';
import { getSiteWidgetExtensionsDir } from '@wix/cli-astro-definitions';
import { createCustomElementFolderValidation } from '../../../dev-center/components/validations/custom-element.js';
import type { ExtensionDef } from '../generate-schema/types.js';
import { defineField } from '../generate-schema/definitions.js';
import { generateCustomElement } from './generate.js';

const schema = z.object({
  extensionType: z.literal('CUSTOM_ELEMENT'),
  name: z.string().describe(defineField({ title: 'Widget name' })),
  folder: z
    .string()
    .regex(/^[a-z][a-z0-9]*(-[a-z0-9]+)+$/)
    .describe(
      defineField({
        title: 'Widget folder',
        description:
          'Must be a valid custom element name: lowercase, starts with a letter, contains at least one hyphen.',
      })
    ),
});

export const customElement: ExtensionDef<typeof schema> = {
  title: 'Custom Element',
  description: 'A site widget built as a custom HTML element',
  group: 'Site',
  documentation:
    'https://dev.wix.com/docs/wix-cli/guides/extensions/site-extensions/site-widgets/add-a-site-widget-extension',
  zodSchema: schema,
  validate: async (projectFolder, data) => {
    const result = createCustomElementFolderValidation(
      getSiteWidgetExtensionsDir(projectFolder)
    )(data.folder);
    return result.valid ? null : result.reason;
  },
  generate: ({ projectFolder, data }) =>
    generateCustomElement(projectFolder, data.folder, data.name),
};
